export default __webpack_public_path__ + "f2f58417da5f09636933ebcb2c963a0e.png";